import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import QuickAddModal from './QuickAddModal';

const PLACEHOLDER = 'https://placehold.co/300x200/f4f4f4/888888?text=PORK+CO.';

// Stock helpers (mirrors ProductDetail / QuickAddModal)
function isAvailable(product) {
  if (product.hasSize) {
    if (typeof product.stock !== 'object' || product.stock === null) return false;
    return Object.values(product.stock).some(v => v > 0);
  }
  return typeof product.stock === 'number' ? product.stock > 0 : false;
}
function totalStock(product) {
  if (product.hasSize) {
    if (typeof product.stock !== 'object' || product.stock === null) return 0;
    return Object.values(product.stock).reduce((a, b) => a + (b || 0), 0);
  }
  return typeof product.stock === 'number' ? product.stock : 0;
}

function ProductCard({ product }) {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [hovered, setHovered] = useState(false);

  // Support both old imageUrl field and new images array
  const images = product.images?.length ? product.images : (product.imageUrl ? [product.imageUrl] : []);
  const mainImg  = images[0] || PLACEHOLDER;
  const hoverImg = images[1] || null; // only show hover swap if a second image exists

  function handleQuickAdd(e) {
    e.stopPropagation();
    setShowModal(true);
  }

  function handleCardClick() {
    navigate(`/product/${product.id}`);
  }

  return (
    <>
      <div
        className="card h-100 product-card"
        onClick={handleCardClick}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{ cursor: 'pointer' }}
      >
        {/* Image area — stacks front and back, fades between them on hover */}
        <div style={{ position: 'relative', height: '320px', overflow: 'hidden', background: '#f4f4f4' }}>
          <img
            src={mainImg}
            className="card-img-top"
            alt={product.name}
            style={{
              height: '320px',
              objectFit: 'contain',
              position: 'absolute',
              top: 0, left: 0, width: '100%',
              opacity: hoverImg && hovered ? 0 : 1,
              transition: 'opacity 0.35s ease',
            }}
            onError={e => { e.target.src = PLACEHOLDER; }}
          />
          {hoverImg && (
            <img
              src={hoverImg}
              className="card-img-top"
              alt={`${product.name} — back`}
              style={{
                height: '320px',
                objectFit: 'contain',
                position: 'absolute',
                top: 0, left: 0, width: '100%',
                opacity: hovered ? 1 : 0,
                transition: 'opacity 0.35s ease',
              }}
              onError={e => { e.target.src = PLACEHOLDER; }}
            />
          )}
        </div>

        <div className="card-body d-flex flex-column p-3">
          <h6 className="card-title fw-bold mb-1" style={{ letterSpacing: '0.02em' }}>
            {product.name}
          </h6>
          <p className="card-text small flex-grow-1 mb-2" style={{ color: '#888' }}>
            {product.description}
          </p>

          {(() => {
            const avail = isAvailable(product);
            const total = totalStock(product);
            if (!avail) return <p className="small mb-1 text-muted">Out of Stock</p>;
            if (total <= 5) return <p className="small mb-1 fw-semibold" style={{ color: '#c84b11' }}>Only {total} left</p>;
            return <p className="small mb-1" style={{ color: '#2e7d32' }}>In Stock</p>;
          })()}

          <div className="d-flex justify-content-between align-items-center mt-auto">
            <span className="fw-bold" style={{ color: '#111' }}>${product.price.toFixed(2)}</span>
            <button
              className="btn btn-piggy btn-sm"
              onClick={handleQuickAdd}
              disabled={!isAvailable(product)}
            >
              Add to Cart
            </button>
          </div>
        </div>
      </div>

      {showModal && (
        <QuickAddModal
          product={product}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
}

export default ProductCard;
